import { useMemo } from 'react';
import { JWT_MEMBER_NUMBER_KEY } from '@/config';

import { decodeToken, getSessionToken } from './utils';

export const useUser = () => {
  const isLogged = useMemo(() => {
    return !!getSessionToken();
  }, []);

  const memberNumber = useMemo(() => {
    if (isLogged) {
      const token = getSessionToken() as string;
      const data = decodeToken(token) as any;
      return data[JWT_MEMBER_NUMBER_KEY];
    }

    return undefined;
  }, [isLogged]);

  return {
    isLogged,
    memberNumber,
  };
};
